/**
 * Created by nijin on 14/2/17.
 */
export enum NotificationType { Info, Success, Error, Warning }

export interface Notification {
  message: string;
  type?: NotificationType;
  typeValue?: string;
  autoHide?: boolean;
  hideDelay?: number;
  isHtml?: boolean;
  allowClose?: boolean;
  hideOnHover?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/core/notify/index.ts